<div
    class="bg-white py-[0.9375rem] lg:px-[7.5rem] px-14 h-[4.375rem] w-full drop-shadow-md flex justify-between desktop-header">
    <div class="flex lg:gap-10 text-[#061F4C] text-nowrap items-center gap-5">
        <div class="flex sm:gap-2 gap-1 items-center justify-center">
            <img class="w-auto h-8" src="/assets/images/shared/text_logo.png" alt="p2p" />
        </div>
        @if (isVerifiedIssuer || isVerifiedInvestor) {
            <button
                type="button"
                [routerLink]="[isIssuer ? '/issuer/funding-list' : '/investor/funding-list']"
                class="cursor-pointer">
                Fund List
            </button>
        }
        @if (isVerifiedIssuer) {
            <div routerLink="issuer/issue-request" class="cursor-pointer">Issue Request</div>
        }
        @if (isVerifiedInvestor) {
            <button type="button" [routerLink]="['/investor/portfolio']" class="cursor-pointer">Portfolio</button>
        }
    </div>
    <div class="flex gap-4 items-center justify-center lg:gap-8">
        @if (isVerifiedInvestor) {
            <div class="cursor-pointer flex gap-[0.62rem]" [matMenuTriggerFor]="menu">
                <div>
                    <div class="text-[#7E7E7E] text-sm text-nowrap">Wallet balance</div>
                    <div class="gradient-text font-bold text-nowrap">
                        {{ totalWalletBalance | currency: 'RM ' : 'code' : '1.2' }}
                    </div>
                </div>

                <div class="flex gap-2 items-center justify-center">
                    <img
                        class="sm:w-auto sm:h-auto w-4 h-4 cursor-pointer"
                        src="/assets/images/shared/CaretDown.png"
                        alt="arrow down" />
                </div>
            </div>

            <mat-menu #menu="matMenu" class="menu profile-menu">
                @for (wallet of walletBalance; track wallet) {
                    <div class="flex items-center gap-[0.88rem] cursor-pointer" [routerLink]="['/wallet']">
                        <img
                            class="size-7"
                            [src]="
                                wallet.walletType == FundingTypeEnum.Conventional
                                    ? '/assets/images/shared/conventional-icon.png'
                                    : '/assets/images/shared/shariah-icon.png'
                            "
                            alt="arrow down" />
                        <div>
                            <div class="text-[#061F4C] text-xs">
                                {{
                                    wallet.walletType == FundingTypeEnum.Conventional
                                        ? 'Conventional Wallet'
                                        : 'Islamic Wallet'
                                }}
                            </div>
                            <div
                                class="font-bold"
                                [ngClass]="
                                    wallet.walletType == FundingTypeEnum.Conventional
                                        ? 'text-[#004BC5]'
                                        : 'text-[#09970D]'
                                ">
                                {{ wallet.currentBalance | currency: 'RM ' : 'code' : '1.2' }}
                            </div>
                        </div>
                    </div>
                }
            </mat-menu>
        }
        <!-- <div class="relative flex-none">
            @if (unreadNotification) {
                <div class="h-6 w-6 flex-none absolute -ml-1 -mt-1">
                    <img src="/assets/images/web/Mask group.png" />
                </div>
            }
            <img
                class="w-8 h-8 cursor-pointer"
                src="/assets/images/web/Bell.png"
                alt="notifications"
                [matMenuTriggerFor]="notification" />
        </div> -->
        <mat-menu #notification="matMenu" class="menu notification-menu">
            <div class="border-b border-[#E2E2E2] flex justify-between">
                <div class="mb-[0.875rem]">{{ unreadNotification }} unread</div>
                <div class="text-[#3875F6] mb-[0.875rem] cursor-pointer">Mark all as read</div>
            </div>
            <div class="[&:not(:last-child)]:border-b border-[#E2E2E2] py-4 flex gap-3 items-start">
                <div class="h-6 w-6 flex-none">
                    <img src="/assets/images/web/Mask group.png" />
                </div>
                <div class="grow">
                    <div class="text-[#061F4C] font-bold mb-2">Loren ipsum dolor</div>
                    <div class="text-[#7E7E7E]">
                        Lorem ipsum dolor sit amet consectetur. Augue habitant nullam gravida sed at orci nisi aliquet
                    </div>
                    <div class="text-[#7E7E7E] mt-4">01/07/2024 10:30 AM</div>
                </div>
            </div>
        </mat-menu>
        <div class="flex gap-2 items-center justify-center" [matMenuTriggerFor]="menu">
            <div
                class="w-10 h-10 flex items-center justify-center bg-[#061F4C] text-white rounded-full text-center cursor-default">
                {{ userDetails.fullName.at(0)?.toLocaleUpperCase() }}
            </div>
            <img
                class="sm:w-auto sm:h-auto w-4 h-4 cursor-pointer"
                src="/assets/images/shared/CaretDown.png"
                alt="arrow down" />
        </div>
        <mat-menu #menu="matMenu" class="menu profile-menu">
            <div class="text-[#061F4C] flex gap-2 items-center cursor-pointer" [routerLink]="['/profile']">
                <img src="/assets/images/web/UserCircle.png" />My Profile
            </div>
            <div class="text-[#FF0000] flex gap-2 items-center cursor-pointer" (click)="logout()">
                <img src="/assets/images/web/SignOut.png" />Log Out
            </div>
        </mat-menu>
    </div>
</div>

<app-mobile-header></app-mobile-header>
